<script>
import {ref} from "vue";
import useTools from "@/use/Tools";
import useValidation from "@/use/Validation";
import useSharedData from "@/use/SharedData";
import axios from "axios";
import ImportModel from "@/views/Tools/Components/ImportModel.vue";
import {useSecurityStore} from "@/stores/Security";

export default {
    name: "OccupationTools",
    components: {ImportModel},
    setup() {
        const {mxRules} = useValidation();
        const {$swal} = useTools();
        const securityStore = useSecurityStore();
        const {
            dialog,
            loading,
            tableElevation,
            page,
            pageCount,
            itemsPerPage,
            paginationListLength,
        } = useSharedData();
        dialog.value = false;
        
        const file = ref(null);
        const occupations = ref([]);
        const search = ref(null);
        
        const headers = [
            {text: 'Code', value: 'code'},
            {text: 'Nom', value: 'name'},
        ];
        
        
        function upload() {
            loading.value = true;
            let formData = new FormData();
            formData.append('file', file.value);
            axios.post(`/tools/getOccupations`, formData).then(response => {
                occupations.value = response.data;
                dialog.value = false;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function apply() {
            loading.value = true;
            axios.post(`/occupations/saveAll`, occupations.value).then(() => {
                $swal.fire('Très Bien', "Importation des fonctions terminer", 'success')
                occupations.value = [];
            }).finally(() => {
                loading.value = false;
            });
        }
        
        return {
            securityStore,
            mxRules,
            dialog,
            loading,
            tableElevation,
            page,
            pageCount,
            itemsPerPage,
            paginationListLength,
            headers,
            file,
            search,
            occupations,
            apply,
            upload,
        }
    }
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.occupations_tools')"
            show-total
            :total="occupations.length"
        >
            <template v-slot:leftToolbar>
                <ImportModel file-name="Fonction.xlsx"/>
            </template>
            <template v-slot:rightToolbar>
                <w-btn
                    color="teal"
                    icon="mdi-import"
                    :text="$t('common.import')"
                    @press="dialog = true"
                />
                <w-btn
                    v-if="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                    color="red"
                    icon="mdi-table-check"
                    :text="$t('common.apply')"
                    :loading="loading"
                    @press="apply"
                />
            
            </template>
            
            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="4">
                            <w-text-field v-model="search" :label="$t('common.search')"/>
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :search="search"
                    :items="occupations"
                    :loading="loading"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                </w-data-table>
            
            </template>
        </w-app>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="700"
        >
            <v-card>
                <w-toolbar color="teal" :title="$t('common.import')"/>
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <w-label :label="$t('common.file')" required/>
                                <w-file-input
                                    v-model="file"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="dialog = false"/>
                    <w-btn-import
                        :loading="loading"
                        @press="upload"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style scoped>

</style>